import React, { useEffect } from "react";
import { connect } from "react-redux";
import { saveShareProfileTeacherID } from "../../redux/homePage/homePage.actions";

const NavigateToShareProfile = (props) => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const idParam = urlParams.get("id");
    const userID = idParam?.substring(0, 24);
    props.saveShareProfileTeacherID(userID);
    props.history.push("/ShareProfile");
  }, []);
  return <div />;
};

const mapDispatchToProps = (dispatch) => ({
  saveShareProfileTeacherID: (id) => dispatch(saveShareProfileTeacherID(id)),
});

export default connect(null, mapDispatchToProps)(NavigateToShareProfile);
